export enum OperationEnum {
  NONE = 'none',
  READ = 'read',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  ACTION = 'action'
};